import { Box, BoxProps } from "@chakra-ui/react";

interface Props extends BoxProps {
  children: React.ReactNode;
  fontSize?: string;
}
export const LifeCycleStageTag: React.FC<Props> = (props) => {
  return (
    <Box
      bg="blackAlpha.700"
      color="white"
      borderRadius="10px"
      py={1}
      px={2}
      fontWeight="semibold"
      width="fit-content"
      fontSize={props.fontSize ?? "xs"}
      {...props}
    />
  );
};
